import React, { SyntheticEvent, useCallback, useState } from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { UseFiltersColumnProps } from 'react-table';

import { Theme } from '@app/theme';
import { Input } from '@app/form';
import { IsEmptyCheckboxFilter } from './IsEmptyCheckboxFilter';
import { useDebouncedSetFilter, useDebouncedHandleChange } from './useDebounce';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    padding: theme.marginBase,
  },
}));

interface Props {
  column: UseFiltersColumnProps<any>;
}

export const TextFilter = ({ column: { filterValue, setFilter } }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();

  const [value, setValue] = useState(filterValue);
  const debouncedSetFilter = useDebouncedSetFilter(setFilter);

  const handleChange = useCallback(
    (e: SyntheticEvent<HTMLInputElement>) => {
      const { value } = e.currentTarget;
      setValue(value);
      debouncedSetFilter(value);
    },
    [debouncedSetFilter],
  );
  const debouncedHandleChange = useDebouncedHandleChange(handleChange);

  return (
    <div className={classes.container}>
      <Input
        small
        noMargin
        value={value}
        onChange={debouncedHandleChange}
        label={t('participants.list.filters.filter')}
      />
      <IsEmptyCheckboxFilter
        debouncedSetFilter={debouncedSetFilter}
        setValue={setValue}
        value={value}
      />
    </div>
  );
};
